import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["lockedContent", "unlockedContent", "alert"];
  static values = { unlockUrl: String };

  async unlock() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
    const response = await fetch(this.unlockUrlValue, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-CSRF-Token": csrfToken,
      },
    });

    if (!response.ok) {
      this.#showError();
      return;
    }

    this.lockedContentTarget.hidden = true;
    this.unlockedContentTarget.hidden = false;
  }

  // private

  #showError() {
    this.alertTarget.hidden = false;
  }
}
